import { KeyRound } from 'lucide-react';
import { lazy } from 'react';

import { label, type FeatureModule } from '@/platform/app/contracts';

const ApiKeysSection = lazy(() =>
  import('./presentation/components/ApiKeysSection').then((m) => ({
    default: m.ApiKeysSection,
  })),
);

/** Developer API keys (settings section). */
export const apiKeysModule: FeatureModule = {
  id: 'api-keys',
  settingsSections: [
    {
      id: 'apiKeys',
      group: 'developers',
      order: 10,
      label: label('settings', 'nav_api_keys'),
      icon: KeyRound,
      Component: ApiKeysSection,
    },
  ],
};
